<mat-dialog-content >

  <mat-select placeholder="Liste Actions" name="avtActions" [(ngModel)]="avtAction_Code">
    <mat-option *ngFor="let action of avtActions" [value]="action.avtAction_Code"
      [matTooltip]="action.avtAction_dateDeb.substring(0,10) +' -> ' + action.avtAction_dateFin.substring(0,10)">
      {{action.avtAction_Intitule}}
    </mat-option>
  </mat-select>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="mat-raised-button" (click)="close()">Close</button>
  <button class="mat-raised-button mat-primary" (click)="save()">Save</button>
</mat-dialog-actions>
<input type="button" style="display: none" (click)="close()" id="btnFermer">